module.exports = __webpack_public_path__ + "static/media/TheYearMyLifeWentDowntheToiletBookCover.3c586de5.jpg";